module.exports = __webpack_public_path__ + "static/media/focus-sub-02.09f0678c.jpg";